<template>
    <div class="dataAny4" v-if="isshow">
        <!--交易数据-->
        <div class="data_box">
            <div class="dataTitle">
                <span><b></b>交易数据</span>
            </div>
            <div class="grayBg">
                <div class="gray_box">
                    <p>访问次数</p>
                    <p>{{summarymap.visits}}</p>
                </div>
                <div class="gray_box">
                    <p>访问人数</p>
                    <p>{{summarymap.visitorcount}}</p>
                </div>
                <div class="gray_box">
                    <p>参与数</p>
                    <p>{{summarymap.ordercount}}</p>
                </div>
                <div class="gray_box">
                    <p>交易订单数</p>
                    <p>{{summarymap.ordersucccount}}</p>
                </div>
                <div class="gray_box">
                    <p>交易金额（元）</p>
                    <p>{{summarymap.totalincome}}</p>
                </div>
            </div>
        </div>
        <!--数据统计-->
        <div class="data_box">
            <div class="filters">
                <div class="dataTitle"><span><b></b>数据统计</span></div>
                <div class="search">
                    <p class="dateSearch">时间筛选</p>
                    <div class="select_box">
                        <div style="width: 100px;">
                            <el-select v-model="dateOptionValue" placeholder="自然天">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                        <div v-show="dateOptionValue === 1">
                            <el-date-picker :clearable="false" v-model="dateValue" align="left" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
                        </div>
                        <div v-show="dateOptionValue === 2">
                            <el-date-picker :clearable="false" v-model="dateValue" align="left" type="week" format="yyyy 第 WW 周" placeholder="选择周" :picker-options="disabledDatePickerOptions"></el-date-picker>
                        </div>
                        <div v-show="dateOptionValue === 3">
                            <el-date-picker :clearable="false" v-model="dateValue" align="left" type="month" placeholder="选择月" :picker-options="disabledDatePickerOptions"></el-date-picker>
                        </div>
                        <div v-show="dateOptionValue === 4">
                            <el-date-picker
                                :picker-options="disabledDatePickerOptions"
                                :clearable="false"
                                format="yyyy-MM-dd"
                                v-model="periodTime"
                                align="left"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <el-button type="primary" @click="searchClick" plain>搜索</el-button>
                    </div>
                    <!--<el-button type="text" @click="handleQuery(1)" class="textBtn">近7天</el-button>-->
                    <!--<el-button type="text" @click="handleQuery(2)" class="textBtn">近30天</el-button>-->
                    <!--<el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels-->
                                    <!--range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">-->
                    <!--</el-date-picker>-->
                    <!--<el-button type="primary" plain @click="handleQuery">搜索</el-button>-->
                </div>
            </div>
            <div class="echarts">
                <lineReportStar :lineDatas="lineDatas" class="lineDatas"></lineReportStar>
            </div>
            <div class="result-list btn-operate-list dataAnyTable">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="xdata" label="时间" class-name="center"></el-table-column>
                    <el-table-column prop="visits" label="访问次数" class-name="center"></el-table-column>
                    <el-table-column prop="visitorcount" label="访问人数" class-name="center"></el-table-column>
                    <el-table-column prop="ordercount" label="参与数" class-name="center"></el-table-column>
                    <el-table-column prop="ordersucccount" label="交易订单数" class-name="center"></el-table-column>
                    <el-table-column prop="totalincome" label="交易金额" class-name="center"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import LineReportStar from 'base/echarts/lineReportStar'
    import {getTradingSituation} from 'api/curriculumApi'
    import {mapActions} from 'vuex'
    export default {
        name: "dataAny4",
        data(){
            return{
                param: {
                    courseid:this.$route.query.innerid?this.$route.query.innerid:'',
                    begintime: '',
                    endtime: '',
                },
                isshow:false, // 是否显示页面
                // lineDatas: {id: 'saleData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
                date: [],
                init: false,
                lineDatas: {id: 'moneyData', subText: '', xdata: [], data: [], legendAddr: 'right', formatter: '{a0}: {c0}<br />{a1}: {c1}'},
                // lineDatas: {
                //     id: 'moneyData',
                //     subText: '',
                //     xdata: [],
                //     data: [
                //         // {title: '创始团队', color: '#4CA6F5', smooth: true, symbol: 'circle', list: ['20', '10', '20', '8', '30', '80', '10', '05', '30', '18']},
                //         // {title: '持股平台', color: '#FECA30', smooth: true, symbol: 'circle', list: ['10', '60', '20', '8', '50', '70', '10', '25', '30', '18']},
                //         // {title: '投资人', color: '#32CC98', smooth: true, symbol: 'circle', list: ['80', '2', '20', '10', '200', '7', '10', '25', '30', '18']},
                //         // {title: '员工', color: '#EC5E69', smooth: true, symbol: 'circle', list: ['30', '10', '20', '8', '50', '70', '60', '10', '30', '18']},
                //         // {title: '其他', color: '#BAC4CD', smooth: true, symbol: 'circle', list: ['2', '1', '20', '104', '50', '100', '10', '25', '30', '18']}
                //     ],
                //     legendAddr: 'left', formatter: '{a0}: {c0}'
                // },
                exportDateOptionValue: '自然天',
                options: [
                    {
                        value: 1,
                        label: '自然天'
                    },
                    {
                        value: 2,
                        label: '自然周'
                    },
                    {
                        value: 3,
                        label: '自然月'
                    },
                    {
                        value: 4,
                        label: '自定义'
                    }
                ],
                dateOptionValue: 1,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', date)
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date()
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', date)
                        }
                    }]
                },
                disabledDatePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                dateValue: new Date(),
                periodTime: '',
                summarymap:{}, // 上面显示块
                tableData:[],
                total:0
            }
        },
        mounted(){
          this.getInfo()
        },
        methods:{
            getWeek(value) {
                // 按周日为一周的最后一天计算
                var date = value
                // 今天是这周的第几天
                var today = date.getDay()
                // 上周日距离今天的天数（负数表示）
                var stepSunDay = -today + 1
                // 如果今天是周日
                if (today === 0) {
                    stepSunDay = -7
                }
                // 周一距离今天的天数（负数表示）
                var stepMonday = 7 - today
                var time = date.getTime()
                var monday = new Date(time + stepSunDay * 24 * 3600 * 1000)
                var sunday = new Date(time + stepMonday * 24 * 3600 * 1000)
                // 本周一的日期 （起始日期）
                var startDate = this.transferDate(monday) // 日期变换
                // 本周日的日期 （结束日期）
                var endDate = this.transferDate(sunday) // 日期变换
                return [startDate, endDate]
            },
            getMonth(value) {
                // 获取当前月的第一天
                var start = value
                start.setDate(1)
                // 获取当前月的最后一天
                var date = value
                var currentMonth = date.getMonth()
                var nextMonth = ++currentMonth
                var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
                var oneDay = 1000 * 60 * 60 * 24
                var end = new Date(nextMonthFirstDay - oneDay)
                var startDate = this.transferDate(start) // 日期变换
                var endDate = this.transferDate(end) // 日期变换
                return [startDate, endDate]
            },
            transferDate(date) {
                console.log(date)
                console.log(date.getFullYear())
                // 年
                var year = date.getFullYear()
                // 月
                var month = date.getMonth() + 1
                // 日
                var day = date.getDate()
                if (month >= 1 && month <= 9) {
                    month = '0' + month
                }
                if (day >= 0 && day <= 9) {
                    day = '0' + day
                }
                var dateString = year + '-' + month + '-' + day
                return dateString
            },
            // 开始/结束时间格式化
            getDateFn(){
                switch (this.dateOptionValue){
                    case 1:
                        this.param.begintime=this.transferDate(this.dateValue)
                        this.param.endtime=this.transferDate(this.dateValue)
                        break
                    case 2:
                        this.param.begintime=this.getWeek(this.dateValue)[0]
                        this.param.endtime=this.getWeek(this.dateValue)[1]
                        break
                    case 3:
                        this.param.begintime=this.getMonth(this.dateValue)[0]
                        this.param.endtime=this.getMonth(this.dateValue)[1]
                        break
                    case 4:
                        this.param.begintime=this.transferDate(this.periodTime[0])
                        this.param.endtime=this.transferDate(this.periodTime[1])
                        break
                }
            },
            // 获取交易图
            getInfo(){
                this.getDateFn()
                this.setLoading(true)
                getTradingSituation({
                    data: Object.assign({}, this.param),
                    success: data => {
                        this.setLoading(false)
                        this.isshow=true
                        this.summarymap=data.data.summarymap
                        this.tableData=data.data.list
                        this.lineDatas.xdata=data.data.xdata
                        this.lineDatas.data=[]
                        this.lineDatas.data.push({
                            title: '访问次数',
                            color: '#5AD8A6',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.visitclientYdata
                        })
                        this.lineDatas.data.push({
                            title: '访问人数',
                            color: '#5B8FF9',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.visitYdata
                        })
                        this.lineDatas.data.push({
                            title: '参与数',
                            color: '#5D7092',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.ordergreateYdata
                        })
                        this.lineDatas.data.push({
                            title: '交易订单数',
                            color: '#E8684A',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.ordercountYdata
                        })
                        this.lineDatas.data.push({
                            title: '交易金额',
                            color: '#F6BD16',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.orderpaymoneyYdata
                        })
                        this.lineDatas.legend = {
                            left: 'right',
                            data: ['访问次数', '访问人数','参与数','交易订单数','交易金额']
                        };
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 搜索
            searchClick() {
                if (this.dateOptionValue === 1 || this.dateOptionValue === 2 || this.dateOptionValue === 3) {
                    if (this.dateValue === '') {
                        this.$message.error(`请选择搜索日期！`)
                        return
                    }
                }
                if (this.dateOptionValue === 4) {
                    if (this.periodTime === '') {
                        this.$message.error(`请选择搜索日期！`)
                        return
                    }
                }
                this.getInfo()
            },
            ...mapActions([
                'setLoading',
            ])
        },
        components:{
            LineReportStar
        }
    }
</script>

<style lang="scss">
    .dataAny4{
        .data_box{
            .dataTitle{
                font-size: 16px;
                font-weight: bold;
                span{
                    display: flex;
                    align-items: center;
                    b{
                        width: 2px;
                        height: 12px;
                        background: #409EFF;
                        margin-right: 5px;
                    }
                }
            }
            .grayBg{
                width: 100%;
                height: 140px;
                background: #F5F7FA;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 20px;
                .gray_box{
                    flex: 1;
                    padding: 0 30px;
                    border-right: 1px solid #DCDFE6;
                    p{
                        font-size: 42px;
                        line-height: 48px;
                    }
                    p:first-child{
                        font-size: 16px;
                    }
                }
                .gray_box:last-child{
                    border-right: none;
                }
            }
            .filters{
                margin: 20px 0;
                .search{
                    display: flex;
                    .dateSearch{
                        margin-right: 10px;
                    }
                    .el-date-editor--daterange.el-input__inner{
                        width: 220px;
                        padding: 0 10px;
                        margin: 0 10px;
                    }
                    .textBtn, .el-button--mini{
                        min-width: 30px;
                    }
                    .select_box{
                        display: flex;
                        justify-content: flex-end;
                        &>div {
                            margin-right: 20px;
                            .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                                width: 240px;
                            }
                            .el-date-editor .el-range-separator {
                                line-height: 34px;
                            }
                        }
                        .el-date-editor.el-input{
                            margin: 0 10px;
                        }
                        .el-input__inner {
                            height: 36px;
                        }
                        .el-input__icon {
                            line-height: 0;
                            height: 36px;
                        }
                        .el-button {
                            height: 36px;
                        }
                    }
                }
            }
            .dataAnyTable{
                margin-top: 20px;
                .el-table__row{
                    height: 60px;
                }
            }
        }
    }
</style>
